import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function AlterarSenha() {
  const [formData, setFormData] = useState({
    senhaAtual: '',
    novaSenha: '',
    confirmarSenha: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.novaSenha !== formData.confirmarSenha) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    if (formData.novaSenha.length < 6) {
      setError('A nova senha deve ter pelo menos 6 caracteres');
      setLoading(false);
      return;
    }

    // Simular alteração de senha
    setTimeout(() => {
      setSuccess(true);
      setLoading(false);
      setFormData({
        senhaAtual: '',
        novaSenha: '',
        confirmarSenha: ''
      });
    }, 2000);
  };

  return (
    <div className="alterar-senha-page">
      <div className="container">
        <div className="page-header">
          <h1>Alterar Senha</h1>
          <p>Mantenha sua conta segura com uma senha forte</p>
        </div>

        <div className="form-container">
          {success ? (
            <div className="success-message">
              <i className="fas fa-check-circle"></i>
              <h3>Senha alterada com sucesso!</h3>
              <p>Sua senha foi atualizada. Use a nova senha no próximo login.</p>
              <Link to="/central" className="btn-primary">Voltar ao Dashboard</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="senha-form">
              {error && <div className="error-message">{error}</div>}
              
              <div className="form-group">
                <label htmlFor="senhaAtual">Senha Atual</label>
                <input
                  type="password"
                  id="senhaAtual"
                  name="senhaAtual"
                  value={formData.senhaAtual}
                  onChange={handleChange}
                  required
                  placeholder="Digite sua senha atual"
                />
              </div>

              <div className="form-group">
                <label htmlFor="novaSenha">Nova Senha</label>
                <input
                  type="password"
                  id="novaSenha"
                  name="novaSenha"
                  value={formData.novaSenha}
                  onChange={handleChange}
                  required
                  placeholder="Digite a nova senha"
                />
                <small>Mínimo 6 caracteres</small>
              </div>

              <div className="form-group">
                <label htmlFor="confirmarSenha">Confirmar Nova Senha</label>
                <input
                  type="password"
                  id="confirmarSenha"
                  name="confirmarSenha"
                  value={formData.confirmarSenha}
                  onChange={handleChange}
                  required
                  placeholder="Confirme a nova senha"
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Alterando...' : 'Alterar Senha'}
                </button>
                <Link to="/central" className="btn-secondary">Cancelar</Link>
              </div>
            </form>
          )}
        </div>

        <div className="dicas-seguranca">
          <h3>Dicas para uma senha segura:</h3>
          <ul>
            <li>Use pelo menos 8 caracteres</li>
            <li>Combine letras maiúsculas e minúsculas</li>
            <li>Inclua números e símbolos</li>
            <li>Evite informações pessoais</li>
            <li>Não use a mesma senha em outros sites</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AlterarSenha; 